import {Injectable} from '@angular/core';
import {Config} from '../models/config';
import {PlayerConfigurationEdit} from '../models/player-configuration';
import * as moment from 'moment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class PlayerConfigMapperService {
    constructor() {}

    formToDb(form: Object , config: Config[] , playerConfigurationEdit: PlayerConfigurationEdit[]): PlayerConfigurationEdit[] {
      const playerConfigurationEditUp = _.cloneDeep(playerConfigurationEdit);

      // this array is use for update delete and add new item (mix list)
      playerConfigurationEdit.forEach((item: PlayerConfigurationEdit , index) => {
        playerConfigurationEditUp[index].value =  this.playerConfigurationEditUpdateValue(form, item);

        config.forEach((configItem: Config) => {
          let index2 = _.findIndex(playerConfigurationEditUp, function ( o: PlayerConfigurationEdit ): boolean {
            return o.key === configItem.controlName[0]});

          if (index2 === -1  && configItem.options.hideAll !== 'hide') {
            playerConfigurationEditUp.push(this.playerConfigurationEditUpdateAddNewItem( configItem, form ));
            index2 = 0;
          }
          if (configItem.options.hideAll !== 'notDisplay') {
            playerConfigurationEditUp[index] = this.playerConfigurationEditUpdateDeleteItem(configItem, playerConfigurationEditUp[index]);
          }
        })
      });
      // this array is use for add new item when we have only new item
      if (playerConfigurationEditUp.length === 0) {
        config.forEach((configItem: Config) => {
          if (configItem.options.hideAll !== 'hide') {
            playerConfigurationEditUp.push(this.playerConfigurationEditUpdateAddNewItem(configItem, form));
          }
        });
      }
      // // Assert all delete are not ok
      // config.forEach((configItem: Config) => {
      //   let index = _.findIndex(playerConfigurationEditUp, function ( o: PlayerConfigurationEdit ): boolean {
      //     return o.key === configItem.controlName[0]});
      //   if (index === -1) {
      //     index = playerConfigurationEditUp.push(this.playerConfigurationEditUpdateAddNewItem(configItem, form));
      //   }
      // });

      return  playerConfigurationEditUp;
  }


   // update pre existant value get from the form
    playerConfigurationEditUpdateValue(form: Object, playerConfigurationEditItem: PlayerConfigurationEdit ): PlayerConfigurationEdit {
      const playerConfigurationEditItem2 =  _.cloneDeep(playerConfigurationEditItem);
      playerConfigurationEditItem2.value = form[playerConfigurationEditItem2.key];
      return playerConfigurationEditItem2.value;
   }

    // update delete values
    playerConfigurationEditUpdateDeleteItem(configItem: Config, playerConfigurationEditItem: PlayerConfigurationEdit ): PlayerConfigurationEdit {

    if (configItem.options.hideAll === 'hide') {
      if (configItem.controlName[0] === playerConfigurationEditItem.key) {
        playerConfigurationEditItem.deleted = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
      }
    }
    return playerConfigurationEditItem;
  }

    //  add new value
    playerConfigurationEditUpdateAddNewItem(configItem: Config, form: Object): PlayerConfigurationEdit {
    let playerConfigurationEditItem;
    playerConfigurationEditItem = {key: configItem.controlName[0] , value: null};
    if (form && typeof  form[configItem.controlName[0]] !== 'undefined' ) {
      playerConfigurationEditItem.value = form[configItem.controlName[0]];
    }
    playerConfigurationEditItem = this.playerConfigurationEditUpdateDeleteItem(configItem, playerConfigurationEditItem);
    return playerConfigurationEditItem;
  }
}
